import { CLEAR_SELECTED_USER, SET_SELECTED_USER } from '@Actions/peopleActions';
export const defaultState = {
    selectedUser: null
};
export function peopleReducer(state = defaultState, action) {
    switch (action.type) {
        case SET_SELECTED_USER: {
            return Object.assign(Object.assign({}, state), { selectedUser: action.payload });
        }
        case CLEAR_SELECTED_USER: {
            return Object.assign(Object.assign({}, state), { selectedUser: null });
        }
        default:
            return state;
    }
}
